import * as types from '../types';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const addItem = (item) => (dispatch) => {
  dispatch({
    type: types.CART_ADD_ITEM,
    payload: item
  })
};

export const updateItem = (item) => (dispatch) => {
  dispatch({
    type: types.CART_UPDATE_ITEM,
    payload: item
  })
};

export const removeItem = (item) => (dispatch) => {
  dispatch({
    type: types.CART_REMOVE_ITEM,
    payload: item
  })
};

export const sendOrder = async (token, items) => {
  const response = await axios.post(API_URL + '/orders/send', {
    items: items.map(({ productId, quantity, size, color }) => ({
      productId, quantity, size, color
    }))
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};
